import React from 'react';
import {DYNAMIC_CSS_GOOGLE_FONTS} from "./google-fonts";

const GoogleWebFontLoader = () => {
    return (
        <style>
            {DYNAMIC_CSS_GOOGLE_FONTS}
        </style>
    );
};

export default GoogleWebFontLoader;
